import { message } from 'antd';
import { IS_FILIAL_SELECTED } from 'constants/auth';
import useMutation from 'hooks/useMutation';
import { cambiarFilial } from './api';

const useCambiarFilial = (origen) => {
  const selectFilial = useMutation({
    mutationFn: cambiarFilial,
    onSuccess: () => {
      if (origen === 'CAMBIAR_FILIAL') {
        localStorage.setItem(IS_FILIAL_SELECTED, true);
      }
       window.location.reload(false);
    },
    onError: (err) => message.error(err.message, 7),
  });

  const handleCambiarFilial = (usuarioId, filialId) => {
    selectFilial.mutate({
      id: usuarioId,
      filiales_id: filialId
    });
  }

  return {
    handleCambiarFilial,
    loading: selectFilial.loading,
  };
};

export default useCambiarFilial;